import React from "react";
import styled from "styled-components";
import logoAfro from "../../assets/images/logo-afro.png";
import { Link } from "react-router-dom";

const Header = () => {
  // const [collapsed, setCollapsed] = useState(true);
  return (
    <HeaderStyled>
    <Link to="/redirect" style={{
      height: "4rem",
      marginTop: "5px"
    }}>
      <img src={logoAfro} alt="logo" />
    </Link>
  </HeaderStyled>
  );
};

export default Header;

const HeaderStyled = styled.div`

  min-height: 7vh;
  min-width: 100%;
  background-image: linear-gradient(135deg, #304352 10%, #130cb7 100%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 50px;  
  }
  .menu-icon {
    position: absolute;
    left: 10px;
    font-size: 30px;
    font-weight: 800;
    z-index: 10;
  }
`;
